import { useState, useCallback } from 'react';

type TUseToggleData = [boolean, () => void];

export const useToggle = (initValue?: boolean): TUseToggleData => {
  const [value, setValue] = useState<boolean>(initValue ?? false);

  const toggleValue = useCallback(
    (): void => {
      setValue((prevValue) => !prevValue);
    },
    [],
  );

  return [value, toggleValue];
};
